import React, { useState, useMemo } from 'react';
import {
  Table, Card, Button, Space, Modal, Form, Input, Select, Radio,
  message, Typography, Tree, Tag, Drawer, Switch, Popconfirm, Tooltip, Alert
} from 'antd';
import {
  SearchOutlined, ReloadOutlined, ApartmentOutlined, TeamOutlined,
  PlusOutlined, EditOutlined, DeleteOutlined, KeyOutlined, QuestionCircleOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

// ─────────────────────────── Mock 数据 ───────────────────────────
// TODO: 联调时替换为接口数据

// 平台全部菜单树（用于企业内角色配菜单、账号权限查看）
const MENU_TREE = [
  { key: '1', title: '首页', children: [] },
  { key: '2', title: '产品管理', children: [
    { key: '2-1', title: '产品开发' },
    { key: '2-2', title: '产品审核', children: [
      { key: '2-2-1', title: '通过审核' },
      { key: '2-2-2', title: '驳回审核' },
    ] },
  ] },
  { key: '3', title: '设备管理', children: [
    { key: '3-1', title: '设备列表' },
    { key: '3-2', title: '设备运维' },
  ] },
  { key: '4', title: '应用服务', children: [
    { key: '4-1', title: '应用管理' },
    { key: '4-2', title: '套餐管理' },
  ] },
  { key: '5', title: '订单管理', children: [
    { key: '5-1', title: '增值订单' },
  ] },
  { key: '6', title: '数据统计', children: [
    { key: '6-1', title: '用户统计' },
    { key: '6-2', title: '收入统计' },
  ] },
];

// 平台定义角色（企业级授权模板）→ 菜单 key 集合
const PLATFORM_ROLE_MENUS = {
  '应用服务商': ['1', '4', '5', '6'],
  '设备制造商': ['1', '2', '3'],
  '渠道商': ['1', '5'],
  '运营商': ['1', '4', '5', '6'],
};
const PLATFORM_ROLE_NAMES = Object.keys(PLATFORM_ROLE_MENUS);

// 企业列表（企业维度）
const MOCK_ENTERPRISES = [
  { key: 'ent1', name: '南京鹤梦信息技术有限公司', id: 'HM-8827-X', roles: ['应用服务商', '设备制造商'] },
  { key: 'ent2', name: '东莞康林物联网有限公司', id: 'JGSf0Nd7', roles: ['设备制造商'] },
  { key: 'ent3', name: '成都云视科技有限公司', id: 'ENT005', roles: ['应用服务商'] },
  { key: 'ent4', name: '上海智联科技有限公司', id: 'SH-ZL-001', roles: ['运营商'] },
  { key: 'ent5', name: '北京华芯电子有限公司', id: 'BJ-HX-88', roles: ['渠道商'] },
];

// 企业内自定义角色（按企业）
const MOCK_INNER_ROLES = {
  ent1: [
    { id: 'r11', name: '运营组', remark: '负责产品与 App 运营', menuKeys: ['1', '4', '5'] },
    { id: 'r12', name: '财务组', remark: '对账与提现', menuKeys: ['1', '5'] },
  ],
  ent2: [
    { id: 'r21', name: '生产组', remark: '生产工单与产测', menuKeys: ['1', '2', '3'] },
  ],
  ent3: [],
  ent4: [
    { id: 'r41', name: '运营组', remark: '', menuKeys: ['1', '4', '5', '6'] },
    { id: 'r42', name: '客服组', remark: '', menuKeys: ['1'] },
    { id: 'r43', name: '技术组', remark: '', menuKeys: ['1', '4'] },
  ],
  ent5: [
    { id: 'r51', name: '销售组', remark: '', menuKeys: ['1', '5'] },
  ],
};

// 企业账号（按企业）
const MOCK_ACCOUNTS = {
  ent1: [
    { id: 'a11', account: 'zhangsan', name: '张三', phone: '13800000001', roleType: 'platform', roleNames: ['应用服务商', '设备制造商'], status: true, visible: false, createTime: '2026-02-27 11:11:22' },
    { id: 'a12', account: 'op01', name: '李四', phone: '13800000002', roleType: 'inner', roleNames: ['运营组'], status: true, visible: true, createTime: '2026-03-01 10:00:00' },
    { id: 'a13', account: 'fin01', name: '王五', phone: '', roleType: 'inner', roleNames: ['财务组'], status: false, visible: true, createTime: '2026-03-05 09:30:00' },
  ],
  ent2: [
    { id: 'a21', account: 'lisi', name: '李四', phone: '13900000001', roleType: 'platform', roleNames: ['设备制造商'], status: true, visible: false, createTime: '2026-01-10 14:00:00' },
    { id: 'a22', account: 'prod01', name: '赵六', phone: '13900000002', roleType: 'inner', roleNames: ['生产组'], status: true, visible: true, createTime: '2026-01-11 09:00:00' },
    { id: 'a23', account: 'prod02', name: '钱七', phone: '', roleType: 'inner', roleNames: ['生产组'], status: true, visible: true, createTime: '2026-01-12 09:00:00' },
    { id: 'a24', account: 'prod03', name: '孙八', phone: '', roleType: 'inner', roleNames: ['生产组'], status: true, visible: true, createTime: '2026-01-13 09:00:00' },
    { id: 'a25', account: 'test-user', name: '测试', phone: '', roleType: 'inner', roleNames: [], status: false, visible: false, createTime: '2026-02-01 09:00:00' },
  ],
  ent3: [
    { id: 'a31', account: 'chengdu_admin', name: '周九', phone: '13700000001', roleType: 'platform', roleNames: ['应用服务商'], status: true, visible: false, createTime: '2026-05-20 09:15:00' },
  ],
  ent4: [
    { id: 'a41', account: 'sh_admin', name: '吴十', phone: '13600000001', roleType: 'platform', roleNames: ['运营商'], status: true, visible: false, createTime: '2025-12-01 10:00:00' },
    { id: 'a42', account: 'op_sh1', name: '郑一', phone: '', roleType: 'inner', roleNames: ['运营组'], status: true, visible: true, createTime: '2026-01-01 10:00:00' },
    { id: 'a43', account: 'cs_sh1', name: '冯二', phone: '', roleType: 'inner', roleNames: ['客服组'], status: true, visible: true, createTime: '2026-01-02 10:00:00' },
    { id: 'a44', account: 'tech_sh1', name: '陈三', phone: '', roleType: 'inner', roleNames: ['技术组'], status: true, visible: true, createTime: '2026-01-03 10:00:00' },
  ],
  ent5: [
    { id: 'a51', account: 'bj_admin', name: '褚四', phone: '13500000001', roleType: 'platform', roleNames: ['渠道商'], status: true, visible: false, createTime: '2026-03-20 10:00:00' },
    { id: 'a52', account: 'sale01', name: '卫五', phone: '', roleType: 'inner', roleNames: ['销售组'], status: true, visible: true, createTime: '2026-03-21 10:00:00' },
  ],
};

// ─────────────────────────── 工具函数 ───────────────────────────

// 企业管理员菜单 = 企业平台定义角色菜单并集
const getAdminMenuKeys = (roles) => {
  const s = new Set();
  (roles || []).forEach((r) => (PLATFORM_ROLE_MENUS[r] || []).forEach((k) => s.add(k)));
  return Array.from(s);
};

const findNode = (key, nodes) => {
  for (const n of nodes) {
    if (n.key === key) return n;
    const r = n.children ? findNode(key, n.children) : null;
    if (r) return r;
  }
  return null;
};

const collectDescendants = (node, out) => {
  out.add(node.key);
  (node.children || []).forEach((c) => collectDescendants(c, out));
};

// 将目录/叶子 key 展开为覆盖的完整节点 key 集合
const expandMenuKeys = (keys) => {
  const out = new Set();
  keys.forEach((k) => {
    const n = findNode(k, MENU_TREE);
    if (n) collectDescendants(n, out);
  });
  return Array.from(out);
};

// 展开所有父节点 key（用于 Tree 默认展开）
const getAllParentKeys = (nodes) => {
  const out = [];
  const t = (ns) => ns.forEach((n) => {
    if (n.children && n.children.length) { out.push(n.key); t(n.children); }
  });
  t(nodes);
  return out;
};

// 判断某个节点是否在管理员菜单范围内（自身或祖先被管理员菜单覆盖）
const isKeyAllowed = (key, adminKeys) => {
  const chain = [];
  const walk = (k, nodes, parents) => {
    for (const n of nodes) {
      if (n.key === k) { chain.push(...parents, k); return true; }
      if (n.children && walk(k, n.children, [...parents, n.key])) return true;
    }
    return false;
  };
  walk(key, MENU_TREE, []);
  return chain.some((k) => adminKeys.includes(k));
};

// 角色配菜单树：超出管理员菜单范围的节点禁用勾选
const buildRoleTree = (nodes, adminKeys, parentAllowed) => nodes.map((n) => {
  const allowed = parentAllowed || adminKeys.includes(n.key);
  return {
    key: n.key,
    title: n.title,
    disableCheckbox: !allowed,
    children: n.children ? buildRoleTree(n.children, adminKeys, allowed) : undefined,
  };
});

const formatNow = () => {
  const d = new Date();
  const p = (v) => String(v).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
};

const ALL_PARENT_KEYS = getAllParentKeys(MENU_TREE);

// ─────────────────────────── 组件 ───────────────────────────

const EnterpriseAdmin = () => {
  const [searchForm] = Form.useForm();
  const [searchValues, setSearchValues] = useState({});

  const [enterprises] = useState(MOCK_ENTERPRISES);
  const [innerRoles, setInnerRoles] = useState(MOCK_INNER_ROLES);
  const [accounts, setAccounts] = useState(MOCK_ACCOUNTS);

  // 当前操作的企业 + Drawer
  const [currentEnt, setCurrentEnt] = useState(null);
  const [roleDrawerOpen, setRoleDrawerOpen] = useState(false);
  const [accountDrawerOpen, setAccountDrawerOpen] = useState(false);

  // 角色弹窗
  const [roleModalOpen, setRoleModalOpen] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [roleForm] = Form.useForm();
  const [roleCheckedKeys, setRoleCheckedKeys] = useState([]);

  // 账号弹窗
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const [editingAccount, setEditingAccount] = useState(null);
  const [accountForm] = Form.useForm();
  const [accountFormValues, setAccountFormValues] = useState({});

  // 密码 / 角色编辑 / 权限查看弹窗
  const [pwdModalOpen, setPwdModalOpen] = useState(false);
  const [pwdTarget, setPwdTarget] = useState(null);
  const [pwdForm] = Form.useForm();

  const [roleEditModalOpen, setRoleEditModalOpen] = useState(false);
  const [roleEditTarget, setRoleEditTarget] = useState(null);
  const [roleEditForm] = Form.useForm();
  const [roleEditFormValues, setRoleEditFormValues] = useState({});

  // 企业列表筛选
  const filteredEnterprises = useMemo(() => {
    const { searchType, keyword, role } = searchValues;
    const kw = keyword ? keyword.trim() : '';
    return enterprises.filter((e) => {
      let match = true;
      if (kw) match = searchType === 'name' ? e.name.includes(kw) : e.id.includes(kw);
      const matchRole = !role || (e.roles || []).includes(role);
      return match && matchRole;
    });
  }, [enterprises, searchValues]);

  const handleSearch = (values) => setSearchValues(values);
  const handleReset = () => {
    searchForm.resetFields();
    setSearchValues({});
  };

  const openRoleDrawer = (ent) => { setCurrentEnt(ent); setRoleDrawerOpen(true); };
  const openAccountDrawer = (ent) => { setCurrentEnt(ent); setAccountDrawerOpen(true); };

  const adminKeys = useMemo(() => (currentEnt ? getAdminMenuKeys(currentEnt.roles) : []), [currentEnt]);
  const roleTreeData = useMemo(() => buildRoleTree(MENU_TREE, adminKeys, false), [adminKeys]);

  // ── 角色操作 ──
  const openRoleModal = (role = null) => {
    setEditingRole(role);
    if (role) {
      roleForm.setFieldsValue({ name: role.name, remark: role.remark });
      setRoleCheckedKeys(role.menuKeys || []);
    } else {
      roleForm.resetFields();
      setRoleCheckedKeys([]);
    }
    setRoleModalOpen(true);
  };

  const saveRole = async () => {
    try {
      const values = await roleForm.validateFields();
      const menuKeys = roleCheckedKeys.filter((k) => isKeyAllowed(k, adminKeys));
      if (menuKeys.length === 0) { message.warning('请选择至少一个有效菜单'); return; }
      if (editingRole) {
        setInnerRoles((prev) => ({
          ...prev,
          [currentEnt.key]: (prev[currentEnt.key] || []).map((r) =>
            r.id === editingRole.id ? { ...r, name: values.name, remark: values.remark, menuKeys } : r),
        }));
        message.success('角色已更新');
      } else {
        const newRole = { id: `role_${Date.now()}`, name: values.name, remark: values.remark, menuKeys };
        setInnerRoles((prev) => ({ ...prev, [currentEnt.key]: [...(prev[currentEnt.key] || []), newRole] }));
        message.success('角色已新增');
      }
      setRoleModalOpen(false);
    } catch (e) { /* 校验失败 */ }
  };

  const deleteRole = (role) => {
    const bound = (accounts[currentEnt.key] || []).filter((a) =>
      a.roleType === 'inner' && (a.roleNames || []).includes(role.name)).length;
    if (bound > 0) { message.warning('该角色下存在绑定账号，不可删除'); return; }
    setInnerRoles((prev) => ({ ...prev, [currentEnt.key]: (prev[currentEnt.key] || []).filter((r) => r.id !== role.id) }));
    message.success('角色已删除');
  };

  // ── 账号操作 ──
  const openAccountModal = (acc = null) => {
    setEditingAccount(acc);
    const initialValues = acc ? {
      account: acc.account, name: acc.name, phone: acc.phone,
      roleType: acc.roleType || 'inner',
      roleValues: acc.roleNames || [],
      visible: acc.visible,
    } : { roleType: 'inner', visible: true };
    accountForm.resetFields();
    accountForm.setFieldsValue(initialValues);
    setAccountFormValues(initialValues);
    setAccountModalOpen(true);
  };

  const saveAccount = async () => {
    try {
      const values = await accountForm.validateFields();
      const roleNames = values.roleValues || [];
      const base = { account: values.account, name: values.name || values.account, phone: values.phone, roleType: values.roleType, roleNames, visible: values.visible };
      if (editingAccount) {
        setAccounts((prev) => ({
          ...prev,
          [currentEnt.key]: (prev[currentEnt.key] || []).map((a) => a.id === editingAccount.id ? { ...a, ...base } : a),
        }));
        message.success('账号已更新');
      } else {
        const newAcc = { ...base, id: `acc_${Date.now()}`, status: true, createTime: formatNow() };
        setAccounts((prev) => ({ ...prev, [currentEnt.key]: [...(prev[currentEnt.key] || []), newAcc] }));
        message.success('账号创建成功');
      }
      setAccountModalOpen(false);
    } catch (e) { /* 校验失败 */ }
  };

  const deleteAccount = (acc) => {
    setAccounts((prev) => ({ ...prev, [currentEnt.key]: (prev[currentEnt.key] || []).filter((a) => a.id !== acc.id) }));
    message.success('账号已删除');
  };

  const toggleStatus = (acc, checked) => {
    setAccounts((prev) => ({
      ...prev,
      [currentEnt.key]: (prev[currentEnt.key] || []).map((a) => a.id === acc.id ? { ...a, status: checked } : a),
    }));
    message.success(`账号 ${acc.account} 已${checked ? '启用' : '禁用'}`);
  };

  const toggleVisible = (acc, checked) => {
    setAccounts((prev) => ({
      ...prev,
      [currentEnt.key]: (prev[currentEnt.key] || []).map((a) => a.id === acc.id ? { ...a, visible: checked } : a),
    }));
    message.success(`账号 ${acc.account} 已设置为对企业${checked ? '可见' : '不可见'}`);
  };

  const openPwdModal = (acc) => { setPwdTarget(acc); pwdForm.resetFields(); setPwdModalOpen(true); };
  const savePwd = async () => {
    try { await pwdForm.validateFields(); message.success(`账号 ${pwdTarget.account} 密码已重置`); setPwdModalOpen(false); }
    catch (e) { /* 校验失败 */ }
  };

  const openRoleEditModal = (acc) => {
    setRoleEditTarget(acc);
    const initialValues = {
      roleType: acc.roleType || 'inner',
      roleValues: acc.roleNames || [],
    };
    roleEditForm.setFieldsValue(initialValues);
    setRoleEditFormValues(initialValues);
    setRoleEditModalOpen(true);
  };
  const saveRoleEdit = async () => {
    try {
      const values = await roleEditForm.validateFields();
      const roleNames = values.roleValues || [];
      setAccounts((prev) => ({
        ...prev,
        [currentEnt.key]: (prev[currentEnt.key] || []).map((a) => a.id === roleEditTarget.id ? { ...a, roleType: values.roleType, roleNames } : a),
      }));
      message.success('账号角色已更新');
      setRoleEditModalOpen(false);
    } catch (e) { /* 校验失败 */ }
  };

  // 角色选项（按类型返回，类型单选互斥）
  const getRoleOptionsByType = (type, ent) => (type === 'platform'
    ? PLATFORM_ROLE_NAMES.map((n) => ({ label: n, value: n }))
    : (innerRoles[ent && ent.key] || []).map((r) => ({ label: r.name, value: r.name })));

  // 账号最终菜单预览 = 继承企业角色 ∪ 直接绑定角色
  const getPreviewMenuKeys = (roleType, roleNames) => {
    if (!currentEnt) return [];
    const s = new Set(getAdminMenuKeys(currentEnt.roles));
    if (roleType === 'platform') {
      roleNames.forEach((n) => (PLATFORM_ROLE_MENUS[n] || []).forEach((k) => s.add(k)));
    } else {
      roleNames.forEach((n) => {
        const role = (innerRoles[currentEnt.key] || []).find((x) => x.name === n);
        ((role && role.menuKeys) || []).forEach((k) => s.add(k));
      });
    }
    return expandMenuKeys(Array.from(s));
  };

  // 实时计算合并菜单预览（根据已选角色动态展示）
  const accountPreviewKeys = getPreviewMenuKeys(accountFormValues.roleType, accountFormValues.roleValues || []);
  const roleEditPreviewKeys = getPreviewMenuKeys(roleEditFormValues.roleType, roleEditFormValues.roleValues || []);

  // 表单值变化时同步预览；切换角色类型时清空已选角色
  const handleAccountFormChange = (changed, all) => {
    if (changed.roleType !== undefined) {
      accountForm.setFieldsValue({ roleValues: [] });
      setAccountFormValues({ ...all, roleValues: [] });
    } else {
      setAccountFormValues(all);
    }
  };
  const handleRoleEditFormChange = (changed, all) => {
    if (changed.roleType !== undefined) {
      roleEditForm.setFieldsValue({ roleValues: [] });
      setRoleEditFormValues({ ...all, roleValues: [] });
    } else {
      setRoleEditFormValues(all);
    }
  };

  // ── 企业列表列 ──
  const entColumns = [
    {
      title: '企业信息', key: 'info',
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500 }}>{r.name}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.id}</Text>
        </div>
      ),
    },
    {
      title: '企业角色', dataIndex: 'roles', key: 'roles',
      render: (roles) => <Space size={[4, 8]} wrap>{(roles || []).map((r) => <Tag color="blue" key={r}>{r}</Tag>)}</Space>,
    },
    {
      title: '账号数', key: 'accountCount', align: 'center', width: 90,
      render: (_, r) => <Button type="link" size="small" onClick={() => openAccountDrawer(r)}>{(accounts[r.key] || []).length}</Button>,
    },
    {
      title: '角色数', key: 'roleCount', align: 'center', width: 90,
      render: (_, r) => <Button type="link" size="small" onClick={() => openRoleDrawer(r)}>{(innerRoles[r.key] || []).length}</Button>,
    },
    {
      title: '操作', key: 'action', width: 180,
      render: (_, r) => (
        <Space size="small">
          <Button type="link" size="small" icon={<ApartmentOutlined />} onClick={() => openRoleDrawer(r)}>管理角色</Button>
          <Button type="link" size="small" icon={<TeamOutlined />} onClick={() => openAccountDrawer(r)}>管理账号</Button>
        </Space>
      ),
    },
  ];

  // ── 角色列表列 ──
  const roleColumns = [
    { title: '角色名称', dataIndex: 'name', key: 'name', render: (v) => <span style={{ fontWeight: 500 }}>{v}</span> },
    { title: '包含菜单数', dataIndex: 'menuKeys', key: 'menuKeys', width: 110, align: 'center', render: (keys) => <Tag color="blue">{(keys || []).length}</Tag> },
    { title: '备注', dataIndex: 'remark', key: 'remark', render: (v) => v || '-' },
    {
      title: '绑定账号数', key: 'bound', width: 110, align: 'center',
      render: (_, role) => {
        const n = (accounts[currentEnt.key] || []).filter((a) => a.roleType === 'inner' && (a.roleNames || []).includes(role.name)).length;
        return <Text type={n > 0 ? undefined : 'secondary'}>{n}</Text>;
      },
    },
    {
      title: '操作', key: 'action', width: 140,
      render: (_, role) => {
        const bound = (accounts[currentEnt.key] || []).filter((a) => a.roleType === 'inner' && (a.roleNames || []).includes(role.name)).length;
        return (
          <Space size="small">
            <Button type="link" size="small" icon={<EditOutlined />} onClick={() => openRoleModal(role)}>编辑</Button>
            {bound > 0 ? (
              <Tooltip title="该角色下存在绑定账号，不可删除">
                <Button type="link" size="small" danger disabled>删除</Button>
              </Tooltip>
            ) : (
              <Popconfirm title="确定删除该角色吗？" onConfirm={() => deleteRole(role)} okText="确定" cancelText="取消" okButtonProps={{ danger: true }}>
                <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
              </Popconfirm>
            )}
          </Space>
        );
      },
    },
  ];

  // ── 账号列表列 ──
  const accountColumns = [
    { title: '登录账号', dataIndex: 'account', key: 'account', fixed: 'left', width: 140, render: (v) => <span style={{ fontWeight: 500 }}>{v}</span> },
    { title: '姓名', dataIndex: 'name', key: 'name', width: 90, render: (v) => v || '-' },
    { title: '手机号', dataIndex: 'phone', key: 'phone', width: 130, render: (v) => v || '-' },
    { title: '角色类型', dataIndex: 'roleType', key: 'roleType', width: 110, render: (t) => <Tag color={t === 'platform' ? 'gold' : 'default'}>{t === 'platform' ? '平台内置' : '企业内部'}</Tag> },
    {
      title: '角色', key: 'roles', width: 220,
      render: (_, a) => (
        <Space size={[4, 4]} wrap>
          {(a.roleNames || []).map((n) => (
            <Tag color={a.roleType === 'platform' ? 'blue' : 'green'} key={n}>{n}</Tag>
          ))}
          <Button type="link" size="small" icon={<EditOutlined />} onClick={() => openRoleEditModal(a)} style={{ padding: 0 }} />
        </Space>
      ),
    },
    {
      title: '状态', dataIndex: 'status', key: 'status', width: 90, align: 'center',
      render: (status, a) => (
        <Switch checked={status} onChange={(c) => toggleStatus(a, c)} checkedChildren="启用" unCheckedChildren="禁用" />
      ),
    },
    {
      title: () => (
        <Space size={4}>
          企业可见
          <Tooltip title="关闭状态，企业列表不可见该账号！">
            <QuestionCircleOutlined style={{ color: '#999' }} />
          </Tooltip>
        </Space>
      ),
      dataIndex: 'visible', key: 'visible', width: 110, align: 'center',
      render: (visible, a) => (
        <Switch checked={visible} onChange={(c) => toggleVisible(a, c)} checkedChildren="可见" unCheckedChildren="隐藏" />
      ),
    },
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 160 },
    {
      title: '操作', key: 'action', fixed: 'right', width: 200,
      render: (_, a) => (
        <Space size="small">
          <Button type="link" size="small" icon={<KeyOutlined />} onClick={() => openPwdModal(a)}>重置密码</Button>
          {a.roleType === 'platform' ? (
            <Tooltip title="平台内置账号不可删除">
              <Button type="link" size="small" danger disabled>删除</Button>
            </Tooltip>
          ) : (
            <Popconfirm title="确定删除该账号吗？" onConfirm={() => deleteAccount(a)} okText="确定" cancelText="取消" okButtonProps={{ danger: true }}>
              <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>企业账号管理</Title>
      </div>

      <Alert
        type="info" showIcon closable
        style={{ marginBottom: 16 }}
        message="平台监管全平台企业账号与角色"
        description="账号「企业可见」控制其是否出现在企业侧「内部账号」列表：平台内置账号默认对企业侧隐藏，企业内部账号默认可见，可逐账号覆盖。"
      />

      {/* 筛选区 */}
      <Card style={{ marginBottom: 16 }}>
        <Form form={searchForm} layout="inline" onFinish={handleSearch}>
          <Form.Item label="" style={{ flex: '1 1 320px', minWidth: 320, marginBottom: 0 }}>
            <Space.Compact style={{ width: '100%' }}>
              <Form.Item name="searchType" noStyle initialValue="name">
                <Select style={{ width: 100 }} options={[{ value: 'name', label: '企业名称' }, { value: 'id', label: '企业ID' }]} />
              </Form.Item>
              <Form.Item name="keyword" noStyle>
                <Input placeholder="请输入企业名称/ID" allowClear />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item name="role" style={{ marginBottom: 0 }}>
            <Select placeholder="选择企业角色" allowClear style={{ width: 160 }} options={PLATFORM_ROLE_NAMES.map((n) => ({ label: n, value: n }))} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* 企业列表 */}
      <Card bodyStyle={{ padding: 0 }}>
        <Table
          columns={entColumns}
          dataSource={filteredEnterprises}
          rowKey="key"
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
        />
      </Card>

      {/* 角色管理 Drawer */}
      <Drawer
        title={`角色管理 - ${currentEnt ? currentEnt.name : ''}`}
        width="70%"
        open={roleDrawerOpen}
        onClose={() => setRoleDrawerOpen(false)}
        extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => openRoleModal()}>新增角色</Button>}
      >
        <Alert
          type="info" showIcon
          style={{ marginBottom: 16 }}
          message="企业内角色菜单上限为该企业管理员当前菜单，超出部分灰显不可勾选"
        />
        <Table
          columns={roleColumns}
          dataSource={currentEnt ? (innerRoles[currentEnt.key] || []) : []}
          rowKey="id"
          pagination={false}
        />
      </Drawer>

      {/* 账号管理 Drawer */}
      <Drawer
        title={`账号管理 - ${currentEnt ? currentEnt.name : ''}`}
        width="70%"
        open={accountDrawerOpen}
        onClose={() => setAccountDrawerOpen(false)}
        extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => openAccountModal()}>创建账号</Button>}
      >
        <Table
          columns={accountColumns}
          dataSource={currentEnt ? (accounts[currentEnt.key] || []) : []}
          rowKey="id"
          scroll={{ x: 1200 }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
        />
      </Drawer>

      {/* 新增/编辑角色 Modal */}
      <Modal
        title={editingRole ? '编辑角色' : '新增角色'}
        open={roleModalOpen}
        onOk={saveRole}
        onCancel={() => setRoleModalOpen(false)}
        width={560}
        destroyOnClose
        okText="保存"
        cancelText="取消"
      >
        <Form form={roleForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="name" label="角色名称" rules={[{ required: true, message: '请输入角色名称' }]}>
            <Input placeholder="例如：运营组、财务组" />
          </Form.Item>
          <Form.Item name="remark" label="备注信息">
            <Input.TextArea rows={2} placeholder="请输入角色备注" />
          </Form.Item>
          <Form.Item label="角色菜单" required>
            <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 300, overflowY: 'auto' }}>
              <Tree
                checkable
                treeData={roleTreeData}
                checkedKeys={roleCheckedKeys}
                onCheck={(keys) => setRoleCheckedKeys(keys)}
                expandedKeys={ALL_PARENT_KEYS}
                autoExpandParent
              />
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* 创建/编辑账号 Modal */}
      <Modal
        title={editingAccount ? '编辑账号' : '创建账号'}
        open={accountModalOpen}
        onOk={saveAccount}
        onCancel={() => setAccountModalOpen(false)}
        width={560}
        destroyOnClose
        okText="保存"
        cancelText="取消"
      >
        <Form form={accountForm} layout="vertical" style={{ marginTop: 16 }} initialValues={{ visible: true }} onValuesChange={handleAccountFormChange}>
          <Form.Item name="account" label="登录账号" rules={[{ required: true, message: '请输入登录账号' }]}>
            <Input placeholder="请输入登录账号" disabled={!!editingAccount} />
          </Form.Item>
          {!editingAccount && (
            <Form.Item name="password" label="登录密码" rules={[{ required: true, message: '请输入登录密码' }]}>
              <Input.Password placeholder="请输入登录密码" />
            </Form.Item>
          )}
          <Form.Item name="name" label="姓名" extra="不填则默认使用登录账号">
            <Input placeholder="请输入姓名" />
          </Form.Item>
          <Form.Item name="phone" label="手机号">
            <Input placeholder="请输入手机号" />
          </Form.Item>
          <Form.Item name="roleType" label="角色类型" rules={[{ required: true, message: '请选择角色类型' }]}>
            <Radio.Group>
              <Radio.Button value="platform">平台定义角色</Radio.Button>
              <Radio.Button value="inner">企业内角色</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="roleValues" label="关联角色">
            <Select mode="multiple" placeholder="请选择角色" options={getRoleOptionsByType(accountFormValues.roleType, currentEnt)} />
          </Form.Item>
          <Form.Item label="合并后菜单">
            <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 260, overflowY: 'auto' }}>
              {accountPreviewKeys.length > 0 ? (
                <Tree checkable={false} treeData={MENU_TREE} checkedKeys={accountPreviewKeys} expandedKeys={ALL_PARENT_KEYS} autoExpandParent />
              ) : <Text type="secondary">请选择角色</Text>}
            </div>
          </Form.Item>
          <Form.Item name="visible" label={<Space size={4}>企业是否可见<Tooltip title="关闭状态，企业列表不可见该账号！"><QuestionCircleOutlined style={{ color: '#999' }} /></Tooltip></Space>} valuePropName="checked">
            <Switch checkedChildren="可见" unCheckedChildren="隐藏" />
          </Form.Item>
        </Form>
      </Modal>

      {/* 重置密码 Modal */}
      <Modal
        title={`重置密码 - ${pwdTarget ? pwdTarget.account : ''}`}
        open={pwdModalOpen}
        onOk={savePwd}
        onCancel={() => setPwdModalOpen(false)}
        destroyOnClose
        okText="提交"
        cancelText="取消"
      >
        <Form form={pwdForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="newPassword" label="新密码" rules={[{ required: true, message: '请输入新密码' }]}>
            <Input.Password placeholder="请输入新密码" />
          </Form.Item>
        </Form>
      </Modal>

      {/* 修改账号角色 Modal */}
      <Modal
        title={`修改角色 - ${roleEditTarget ? roleEditTarget.account : ''}`}
        open={roleEditModalOpen}
        onOk={saveRoleEdit}
        onCancel={() => setRoleEditModalOpen(false)}
        destroyOnClose
        okText="保存"
        cancelText="取消"
      >
        <Form form={roleEditForm} layout="vertical" style={{ marginTop: 16 }} onValuesChange={handleRoleEditFormChange}>
          <Form.Item name="roleType" label="角色类型" rules={[{ required: true, message: '请选择角色类型' }]}>
            <Radio.Group>
              <Radio.Button value="platform">平台定义角色</Radio.Button>
              <Radio.Button value="inner">企业内角色</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="roleValues" label="关联角色">
            <Select mode="multiple" placeholder="请选择角色" options={getRoleOptionsByType(roleEditFormValues.roleType, currentEnt)} />
          </Form.Item>
          <Form.Item label="合并后菜单">
            <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 260, overflowY: 'auto' }}>
              {roleEditPreviewKeys.length > 0 ? (
                <Tree checkable={false} treeData={MENU_TREE} checkedKeys={roleEditPreviewKeys} expandedKeys={ALL_PARENT_KEYS} autoExpandParent />
              ) : <Text type="secondary">请选择角色</Text>}
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EnterpriseAdmin;
